import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { PartnerListInterface } from '../types/partner-list';
import {
  PartnerListFilter,
  defaultPartnerListFilter,
} from '../types/partner-list-filter';

export const PARTNER_LIST_STATE = 'partnerList';

export interface PartnerListState {
  filter: PartnerListFilter;
  dataSource: DataSource<PartnerListInterface[]>;
}

export const initialDataSource: DataSource<PartnerListInterface[]> =
  Object.freeze({
    ...initialPageableData,
    rawData: [],
  });

export const initialPartnerListState: PartnerListState = Object.freeze({
  filter: defaultPartnerListFilter,
  dataSource: {
    ...initialDataSource,
  },
});
